<template>
	<div>
		<v-container>
			<v-card :loading="loading">
				<v-card-title primary-title>
					<div class="title">Clinic Information</div>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid">
						<v-row dense>
							<v-col cols="12" sm="6" class="py-0">
								<v-text-field v-model="clinicName" label="Name" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" sm="6" class="py-0">
								<v-text-field v-model="clinicSAdmin" label="Super Admin" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" sm="6" class="py-0">
								<v-text-field v-model="clinicPhone" label="Phone" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" sm="6" class="py-0">
								<v-text-field v-model="clinicWebsite" label="Website" :rules="[rules.required]"></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-textarea v-model="clinicAddress" label="Address" :rules="[rules.required]"></v-textarea>
							</v-col>

							<v-col cols="12">
								<v-divider></v-divider>
							</v-col>

							<v-col class="expand">
								<div class="title">Subclinics</div>
							</v-col>

							<v-col class="shrink">
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn icon color="success" v-on="on" @click="openSubClinicDialog">
											<v-icon color="success">mdi-plus</v-icon>
										</v-btn>
									</template>

									<span>New Clinic</span>
								</v-tooltip>
							</v-col>

							<v-col cols="12" class="py-4">
								<v-data-table
									:headers="headers"
									:items="subclinics"
									hide-default-footer
									class="elevation-1"
								>
									<template #item.actions="{ item }">
										<div>...</div>
									</template>
								</v-data-table>
							</v-col>

							<v-col cols="12" class="py-0 text-center">
								<v-btn
									color="primary"
									class="text-none mx-1"
									rounded
									:disabled="!valid"
									@click="updateClinic"
								>
									<template>Update</template>
								</v-btn>
								<v-btn color="error" class="text-none mx-1" rounded outlined @click="goHome">Cancel</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-container>

		<v-dialog v-model="newSubClinicDialog" persistent max-width="500px">
			<v-card>
				<v-card-title>
					<span class="headline">New Sub-Clinic</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-form v-model="subClinicValid">
							<v-row dense>
								<v-col cols="12" sm="6" class="py-0">
									<v-text-field v-model="subClinicName" label="Name" :rules="[rules.required]"></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" class="py-0">
									<v-text-field v-model="subClinicSAdmin" label="Super Admin" :rules="[rules.required]"></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" class="py-0">
									<v-text-field v-model="subClinicPhone" label="Phone" :rules="[rules.required]"></v-text-field>
								</v-col>

								<v-col cols="12" sm="6" class="py-0">
									<v-text-field v-model="subClinicWebsite" label="Website" :rules="[rules.required]"></v-text-field>
								</v-col>

								<v-col cols="12" class="py-0">
									<v-textarea v-model="subClinicAddress" label="Address" :rules="[rules.required]"></v-textarea>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="blue darken-1"
						text
						:loading="loadingAction"
						@click.native="newSubClinicDialog = false"
					>
						<template>Close</template>
					</v-btn>
					<v-btn
						color="blue darken-1"
						text
						:disabled="!subClinicValid"
						:loading="loadingAction"
						@click.native="storeNewSubClinic"
					>
						<template>Save</template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
const axios = require("axios");

export default {
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/rules-mixin").default,
		require("@/mixins/router-mixin").default
	],
	data: () => ({
		valid: false,
		loading: true,
		clinicName: null,
		clinicWebsite: null,
		clinicSAdmin: null,
		clinicPhone: null,
		clinicAddress: null,
		headers: [
			{
				text: "ID",
				align: "left",
				value: "id"
			},
			{
				text: "Clinic Name",
				align: "left",
				value: "description"
			},
			{
				text: "Admin",
				align: "left",
				value: "owner"
			},
			{
				text: "Actions",
				align: "center",
				value: "actions",
				sortable: false
			}
		],
		subclinics: [],
		subClinicValid: false,
		subClinicSAdmin: null,
		subClinicName: null,
		subClinicAddress: null,
		subClinicPhone: null,
		subClinicWebsite: null,
		newSubClinicDialog: false,
		loadingAction: false
	}),
	mounted() {
		this.getClinicInfo();
		this.getClinicInfo();
	},
	methods: {
		openSubClinicDialog() {
			this.subClinicSAdmin = null;
			this.subClinicName = null;
			this.subClinicAddress = null;
			this.subClinicPhone = null;
			this.subClinicWebsite = null;
			this.newSubClinicDialog = true;
		},
		getClinicInfo() {
			// TODO
			// Add pagination

			var id = this.$store.state.userInfo.nationalId;

			const url = this.BACKEND_URL + "/api/getClinicByUser/" + id;
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						thisVue.loading = false;
						console.log("200");
						console.log(response.data);
						var clinic = response.data.clinic;
						var subclinics = response.data.sub.data;
						setTimeout(() => {
							thisVue.clinicName = clinic.description;
							thisVue.clinicWebsite = clinic.website;
							thisVue.clinicSAdmin = clinic.owner;
							thisVue.clinicPhone = clinic.phone;
							thisVue.clinicAddress = clinic.location;

							thisVue.subclinics = subclinics;
						}, 50);
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		goHome() {
			this.$router.push("/dashboard/home/");
		},
		updateClinic() {
			// var id = this.$route.params.clinicId;

			const url = this.BACKEND_URL + "/api/updateClinic";

			var data = new FormData();

			data.append("id", this.$route.params.clinicId);
			data.append("description", this.clinicName);
			data.append("website", this.clinicWebsite);
			data.append("owner", this.clinicSAdmin);
			data.append("phone", this.clinicPhone);
			data.append("location", this.clinicAddress);

			var token = this.getBackendToken();
			data.append("token", token);

			let thisVue = this;
			let config = {};

			axios
				.post(url, data, config)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.$store.commit("pushNotification", {
							message: `Data updated for ${thisVue.clinicName} clinic`
						});
						thisVue.goHome();
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		storeNewSubClinic() {
			this.loadingAction = true;
			const url = this.BACKEND_URL + "/api/storeClinic";

			var data = new FormData();

			data.append("owner", this.subClinicSAdmin);
			data.append("description", this.subClinicName);
			data.append("location", this.subClinicAddress);
			data.append("phone", this.subClinicPhone);
			data.append("website", this.subClinicWebsite);
			data.append("parentId", this.$route.params.clinicId);

			var token = this.getBackendToken();
			data.append("token", token);

			let thisVue = this;
			let config = {};

			axios
				.post(url, data, config)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						thisVue.$store.commit("pushNotification", {
							message: `New sub-clinic ${thisVue.subClinicName} added.`
						});
						thisVue.newSubClinicDialog = false;
						thisVue.loadingAction = false;
					}
				})
				.catch(error => {
					console.error(error);
					thisVue.loadingAction = false;
				});
		}
	}
};
</script>

<style>
.v-input--selection-controls:not(.v-input--) .v-input__slot,
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
	margin-bottom: 0;
}
.v-input--checkbox,
.v-input--radio-group {
	margin-top: 0;
	margin-bottom: 0;
}
</style>
